import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import cancelIcon from '@ckeditor/ckeditor5-core/theme/icons/cancel.svg';
import deleteIcon from './picbutton_27_deletetextobject_right.svg';

export default class DeleteButton extends Plugin {

	static get pluginName() {
		return 'DeleteButton';
	}

    /**
     * (`config.deleteButton`), which:
     *
     * * may be defined as an `Object`:
     *
     *		deleteButton: {
     *		    label: 'your tooltip',
     *		 	icon: 'icon-name'; 'deleteIcon' for deleteIcon.svg (default: cancel.svg),
     *		    action: function to be called
     *		    active: boolean or function returning a boolean if button is active
     *		    iconClass: CSS class for icon, default is empty
     *		}
     */
	init() {
		const editor = this.editor;
        const config = editor.config.get( 'deleteButton' ) || {};
        editor.set( 'isDeletable', !!config.active );
        editor.ui.componentFactory.add( 'deleteButton', locale => {
            const view = new ButtonView( locale );

            view.set( {
                label: config.label || 'Delete',
                icon: this.getIcon(config),
                class: config.iconClass,
                isVisible: !!config.active,
                tooltip: true
            } );

            view.bind( 'isVisible' ).to( editor, 'isDeletable' );

            // Callback executed once the image is clicked.
            view.on( 'execute', () => {
                if (config.action && typeof config.action === "function") {
                    config.action();
                }
            } );

            return view;
        } );
    }

    getIcon(config) {
        if (config.hasOwnProperty('icon')) {
            return config.icon === 'deleteIcon' ? deleteIcon : config.icon;
        }
        return cancelIcon;
    }


};
